import Container from './components/UploadContainer/UploadContainer';
import { setAwsConfig } from './redux/awsConfig/actionCreators';
import { setInfoFields } from './redux/infoFields/actionCreators';
import rootReducer from './redux/rootReducer';
import { useEffect, useRef } from 'react';
import ReactNotification from 'react-notifications-component';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore, compose } from 'redux';
import thunk from 'redux-thunk';

import {
  setDisplayOnlyRequiredInfoFields,
  setCurrentTrialName,
  setCurrentLibraryId,
  setCurrentLibraryName,
  setCurrentCollectionId,
  setCurrentCollectionName,
  setAuthenticityToken,
  setNotificationDomRef,
} from './redux/internal/actionCreators';

// istanbul ignore next
// if (process.env.NODE_ENV === 'development') { middleware.push(logger) }
const middleware = [thunk];

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(rootReducer, {}, composeEnhancers(applyMiddleware(...middleware)));

export function Uploader(props) {
  const {
    awsConfig,
    infoFields,
    displayOnlyRequiredInfoFields,
    currentTrialName,
    currentLibraryId,
    currentLibraryName,
    currentCollectionId,
    currentCollectionName,
    authenticityToken,
  } = props;

  const notificationDomRef = useRef(null);

  // Get provided values into Redux for later access
  // TODO: Write a test for this hook
  // Currently (22nd July 2019) can't as Enzyme doesn't support Hooks yet
  // https://github.com/airbnb/enzyme/issues/2011
  /* istanbul ignore next */
  useEffect(() => {
    // TODO: Clean these all up into one action
    const config = awsConfig ? JSON.parse(awsConfig) : {};
    store.dispatch(setAwsConfig(config));
    store.dispatch(setInfoFields(infoFields));
    store.dispatch(setDisplayOnlyRequiredInfoFields(displayOnlyRequiredInfoFields || false)); // Default to false if prop is undefined
    store.dispatch(setCurrentTrialName(currentTrialName));
    store.dispatch(setCurrentLibraryId(currentLibraryId));
    store.dispatch(setCurrentLibraryName(currentLibraryName));
    store.dispatch(setCurrentCollectionId(currentCollectionId));
    store.dispatch(setCurrentCollectionName(currentCollectionName));
    store.dispatch(setAuthenticityToken(authenticityToken));
    store.dispatch(setNotificationDomRef(notificationDomRef));
  }, []);

  return (
    <Provider store={store}>
      <ReactNotification ref={notificationDomRef} />
      <Container />
    </Provider>
  );
}

export default Uploader;
